import React, { useState } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { Alert, FormGroup, Col, ControlLabel } from 'react-bootstrap';
import { actions } from '../../../../../../common/components/Postcode/redux/PostcodeActions';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { Button } from '../../../../../../common/components';
import InputError from '../../../InputError/InputError';
const Buttons = ({ populated, handlePostcodeSearch, handleAddressClear, isLoading }) => {
  if (populated) {
    return (
      <Button
        type="button"
        className="search-btn"
        handleClick={handleAddressClear}
        label="Clear"
        isLoading={isLoading}
      />
    );
  }
  return (
    <Button
      type="button"
      className="search-btn"
      handleClick={handlePostcodeSearch}
      label="Search"
      isLoading={isLoading}
    />
  );
};

const PostcodeMenu = ({
  addresses,
  labelSize,
  fieldSize,
  handleAddressSelect,
  showAlert,
  handleAlertDismiss,
}) => {
  if (!addresses.data) {
    return null;
  }

  const noAddressFound = !addresses.data.length;

  if (noAddressFound && showAlert) {
    return (
      <div className="not-found-alert fade in">
        <Alert bsStyle="danger" onDismiss={handleAlertDismiss}>
          No addresses were found with the given criteria.
        </Alert>
      </div>
    );
  }

  const options = addresses.data?.map((address) => {
    return {
      label: address.attributes.name,
      value: address.id,
    };
  });

  return (
    <FormGroup>
      <Col sm={fieldSize} smOffset={labelSize} className="fadein-fields">
        <div>
          <Select
            onChange={handleAddressSelect}
            options={options}
            placeholder="Please select your address from the following..."
            clearable={false}
          />
        </div>
      </Col>
    </FormGroup>
  );
};

const PostcodeLookup = ({
  updateAddress,
  clearAddress,
  actions,
  addresses,
  label,
  infoButton,
  isLoading,
  disabled,
  input,
  meta,
  placeholder,
  labelSize,
  fieldSize,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const [populated, setPopulated] = useState(false);

  const handleAlertDismiss = () => {
    setShowAlert(false);
  };

  const handleClearAddress = () => {
    clearAddress();
    actions.clearSelection();
    setPopulated(false);
  };

  const handlePostcodeSearch = () => {
    setShowAlert(true);
    actions.getAddresses(input.value);
  };

  const handleAddressSelect = (addressId) => {
    Promise.resolve(actions.getAddress(addressId.value)).then((address) => {
      if (address && address.attributes) {
        delete address.attributes.organisation;
        delete address.attributes.name;
        updateAddress(address.attributes);
        actions.clearSelection();
        setPopulated(true);
      }
    });
  };
  const onPostcodeChange = (event) => {
    const value = event.target.value;
    if (value) {
      input.onChange(value.toUpperCase());
    }
  };

  return (
    <div>
      <FormGroup>
        <Col sm={labelSize}>
          <ControlLabel>
            {label}
            {infoButton}
          </ControlLabel>
        </Col>
        <Col sm={fieldSize - 2} className="address-field">
          <input
            className="form-control"
            disabled={disabled}
            value={input.value}
            placeholder={placeholder || ''}
            type={'text'}
            onChange={onPostcodeChange}
          />
          <InputError meta={meta} />
        </Col>
        {!disabled && (
          <Col sm={2} className="search-btn-container">
            <Buttons
              populated={populated}
              handlePostcodeSearch={handlePostcodeSearch}
              handleAddressClear={handleClearAddress}
              isLoading={isLoading}
            />
          </Col>
        )}

        {/*<Col sm={10} smOffset={labelSize}>*/}
        {/* */}
        {/*</Col>*/}
      </FormGroup>

      <PostcodeMenu
        addresses={addresses}
        handleAddressSelect={handleAddressSelect}
        showAlert={showAlert}
        handleAlertDismiss={handleAlertDismiss}
        labelSize={labelSize}
        fieldSize={fieldSize}
      />
    </div>
  );
};

export default connect(
  (state) => {
    return {
      addresses: state.postcode.addresses,
      selection: state.postcode.selection,
      isLoading: state.postcode.isLoading,
    };
  },
  (dispatch) => ({
    change: bindActionCreators(change, dispatch),
    actions: bindActionCreators(actions, dispatch),
    dispatch,
  }),
)(PostcodeLookup);
